import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Trash2 } from 'lucide-react';

const AdminHR = () => {
  const [applications, setApplications] = useState([]);

  useEffect(() => {
    fetchApplications();
  }, []);

  const fetchApplications = async () => {
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/hr-applications`, {
        withCredentials: true
      });
      setApplications(data);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-left">
          <thead className="bg-slate-50 border-b border-slate-200 text-slate-600 text-sm">
            <tr>
              <th className="p-4 font-semibold">Tarih</th>
              <th className="p-4 font-semibold">İsim Soyisim</th>
              <th className="p-4 font-semibold">Telefon</th>
              <th className="p-4 font-semibold">Departman</th>
              <th className="p-4 font-semibold">Özgeçmiş</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {applications.length === 0 ? (
              <tr><td colSpan="5" className="p-8 text-center text-slate-500">Henüz başvuru bulunmuyor.</td></tr>
            ) : (
              applications.map(app => (
                <tr key={app._id} className="hover:bg-slate-50 transition-colors">
                  <td className="p-4 text-sm text-slate-500">
                    {new Date(app.date_created).toLocaleDateString('tr-TR')}
                  </td>
                  <td className="p-4 font-medium text-slate-900">{app.name}</td>
                  <td className="p-4 text-sm text-slate-600">{app.phone}</td>
                  <td className="p-4 text-sm text-slate-600 capitalize">{app.department || 'Genel Başvuru'}</td>
                  <td className="p-4">
                    <a 
                      href={`${process.env.REACT_APP_BACKEND_URL}${app.cv_url}`} 
                      target="_blank" 
                      rel="noreferrer"
                      className="text-blue-600 font-medium text-sm hover:underline"
                    >
                      İndir / Görüntüle
                    </a>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminHR;
